import { atom } from '@exodus/headless-ui';
const originAtom = atom();
export default originAtom;
